import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import FileUpload from "./FileUpload";
import "bootstrap/dist/css/bootstrap.min.css";
import { Header } from "./components/Header";
import Footer from "./components/Footer";
import ProductA from "./components/ProductA";
import { NavLink } from "react-router-dom";

const TableComponent = () => {
  const [items, setItems] = useState([]);

  const API_URL = "/api";

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/sites`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();

      setItems(data);
      localStorage.setItem("sites", JSON.stringify(data));

      console.log("Fetched Data:", data?.isheet?.data?.item);
      setItems(data?.isheet?.data?.item);
      console.log(items);
    } catch (error) {
      // setError(error.message);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="app-container">
      <div className="container-fluid">
        <main className="content">
          <Header />

          <div className="row" style={{ marginTop: "30px" }}>
            <div className="col-md-6">
              <NavLink
                to="/producta"
                className={({ isActive }) =>
                  `btn btn-lg ${
                    isActive ? "btn-dark" : "btn-outline-secondary"
                  }`
                }
              >
                Product A
              </NavLink>

              <NavLink
                to="/productb"
                className={({ isActive }) =>
                  `btn btn-lg ${
                    isActive ? "btn-dark" : "btn-outline-secondary"
                  } ms-2`
                }
              >
                Product B
              </NavLink>
            </div>
          </div>

          <div className="row" style={{ background: "#fefefe" }}>
            <div className="col-md-4">
              <FileUpload onUploadSuccess={fetchData} />
            </div>

            <div className="col-md-8">
              <ProductA items={items} />
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default TableComponent;
